import {
  GET_THUOC_TINH_TAI_SAN,
  GET_THUOC_TINH_TAI_SAN_SUCCESS,
  GET_THUOC_TINH_TAI_SAN_FAILURE,
  GET_THUOC_TINH_TAI_SAN1,
  GET_THUOC_TINH_TAI_SAN1_SUCCESS,
  GET_THUOC_TINH_TAI_SAN1_FAILURE,
} from "./actionTypes";

export const getThuocTinhTaiSan = (dataSearch) => ({
  type: GET_THUOC_TINH_TAI_SAN,
  dataSearch,
});

export const getThuocTinhTaiSanSuccess = (data) => ({
  type: GET_THUOC_TINH_TAI_SAN_SUCCESS,
  payload: data,
});

export const getThuocTinhTaiSanFailure = () => ({
  type: GET_THUOC_TINH_TAI_SAN_FAILURE,
});

export const getThuocTinhTaiSan1 = (dataSearch) => ({
  type: GET_THUOC_TINH_TAI_SAN1,
  dataSearch,
});

export const getThuocTinhTaiSan1Success = (data) => ({
  type: GET_THUOC_TINH_TAI_SAN1_SUCCESS,
  payload: data,
});

export const getThuocTinhTaiSan1Failure = () => ({
  type: GET_THUOC_TINH_TAI_SAN1_FAILURE,
});
